module.exports = __webpack_public_path__ + "static/media/bl.f933a8f3.svg";